import { render, staticRenderFns } from "./JoinSalesUser.vue?vue&type=template&id=5ac87970&scoped=true&"
import script from "./JoinSalesUser.vue?vue&type=script&lang=js&"
export * from "./JoinSalesUser.vue?vue&type=script&lang=js&"
import style0 from "./JoinSalesUser.vue?vue&type=style&index=0&id=5ac87970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac87970",
  null
  
)

export default component.exports